import React from 'react';
import { Link } from 'react-router-dom';

import moment from 'moment-timezone';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { authActionCreators } from '../../stores/lis-auth-store';
import { DuplicateWatchlistWarning, sortLegislations } from '../../services/legislation-helper-service';
import Select from 'react-select';

class LegislationProfiles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSection: window.innerWidth <= 900 ? false : true, //900px is when mobile layout is used (set in mobile.scss); collapse by default
            name: '',
            filteredWatchlists: [],
            filteredWatchlistsValue: ''
        };
        this.toggleSection = this.toggleSection.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.createCollection = this.createCollection.bind(this);
        this.filterWatchlist = this.filterWatchlist.bind(this);
    }

    toggleSection() {
        this.setState(state => ({
            showSection: !state.showSection
        }));
    }

    handleTextChange(key, val) {
        this.setState({
            [key]: val
        });
    }

    createCollection() {
        let collection = {
            Name: this.state.name,
            Description: "Created on " + moment().tz('America/New_York').format('MM/DD/YYYY'),
            WatchListLegislation: []
        };
        this.props.createCollection(collection);
        this.setState({
            name: ''
        });
    }

    filterWatchlist(e) {
        const val = e.target.value.toLowerCase();
        this.setState({
            // Map is used to preserve the original index
            filteredWatchlists: this.props.collections.map(coll => {
                if ((coll.Description && coll.Description.toLowerCase().includes(val)) || (coll.Name && coll.Name.toLowerCase().includes(val))) {
                    return coll;
                } else {
                    return null;
                }
            }),
            filteredWatchlistsValue: val
        })
    }

    render() {
        const watchlists = this.state.filteredWatchlistsValue ? this.state.filteredWatchlists : this.props.collections;
        const selectedWatchlistIndex = this.props.collections[this.props.selectedCollectionIndex] ? watchlists.findIndex(w => w && w.WatchListID === this.props.collections[this.props.selectedCollectionIndex].WatchListID) : -1;
        const handleNavigation = (listIndex) => {
            !this.props.collectionIsSaving && !this.props.isLoading && !this.props.isFetching && this.props.selectCollection(this.props.selectedCollectionIndex === listIndex ? -1 : listIndex)
        }

        const handleKeyDown = (e, listIndex) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleNavigation(listIndex);
            } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();
                const currentIndex = listIndex;
                const current = Array.from(document.getElementsByClassName('watchlist-collection-item'));
                let nextIndex = e.key === 'ArrowUp' ? currentIndex - 1 : currentIndex + 1;
                if (nextIndex < 0) {
                    nextIndex = current.length - 1;
                } else if (nextIndex >= current.length) {
                    nextIndex = 0;
                }
                current[nextIndex].focus();
            } else if (e.key === 'Tab') {
                e.stopPropagation();
            }
        }

        const tabToSelectedFromScroll = e => {
            if (this.props.selectedCollectionIndex >= 0 && e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                const current = Array.from(document.getElementsByClassName('watchlist-collection-item'))[this.props.selectedCollectionIndex];
                current.focus();
            }
        }

        const isItADupe = !!watchlists.find(s => s.Name === this.state.name);

        return (
            <div className={this.props.isBillManagement ? "dlas-forms side-form advanced-search management" : "dlas-forms side-form advanced-search"} style={{marginBottom: '15px'}}>
                <div className={"header flex-row flex-vertical-center " + (!this.state.showSection && 'closed')} onClick={this.toggleSection} >
                    <h3 className="center category-header">Lobbyist-in-a-Box</h3>
                    <button type="button" className={this.state.showSection ? "arrow-up white-chevron" : "arrow-down white-chevron"}></button>
                </div>
                {this.state.showSection &&
                    <div className="content my-watchlist-content">
                        {this.props.isAuthor ?
                            <div>
                                <fieldset>
                                    <div>
                                        <label htmlFor="sr-watchlist-name" className="txt-dark-blue small-text">Create a new watchlist</label>
                                        <div className="inner-grid three-and-one" style={{ columnGap: '10px' }}>
                                            <input
                                                aria-label="Name"
                                                id="sr-watchlist-name"
                                                type="text"
                                                placeholder="Name"
                                                value={this.state.name}
                                                onChange={e => this.handleTextChange("name", e.target.value)}
                                            />
                                            <button aria-label="create watchlist" className="button" disabled={this.props.collectionIsSaving || !this.state.name || isItADupe} onClick={this.createCollection} type="button">Create</button>
                                            {isItADupe && <DuplicateWatchlistWarning styleAdjustments={{ marginTop: '-5px' }} />}
                                            <hr className="faded-line full-line" />
                                        </div>
                                        {watchlists.length > 0 && <>
                                            <div className='my-watchlists-header'>
                                                <div>My Watchlists</div>
                                                <Select
                                                    id="my-watchlists-sort"
                                                    options={[{ label: 'A-Z', value: 'ALPHABETICAL' }, { label: 'Last modified', value: 'MODIFICATION_DATE' }]}
                                                    placeholder="All"
                                                    onChange={(opt) => { this.props.updateSortWatchlists(opt.value) }}
                                                    value={this.props.sortWatchlistsBy === 'MODIFICATION_DATE' ? { label: 'Last modified', value: 'MODIFICATION_DATE' } : { label: 'A-Z', value: 'ALPHABETICAL' }}
                                                    classNamePrefix='my-watchlists-sorting-options'
                                                />
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <label htmlFor="sr-watchlist-find" className="screen-reader-only">Find a watchlist</label>
                                                <input
                                                    id="sr-watchlist-find"
                                                    type="text"
                                                    placeholder="Find a watchlist"
                                                    value={this.state.filteredWatchlistsValue}
                                                    onChange={this.filterWatchlist} />
                                            </div>
                                        </>
                                        }
                                    </div>
                                    {this.props.error && <span className="small-text fail">{this.props.error}</span>}
                                    {this.props.isLoading ?
                                        <div className="spinner center-spinner"></div>
                                        :
                                        watchlists.length > 0 &&
                                        <div className="checkbox-container watchlist-collection-list" onKeyDown={e => tabToSelectedFromScroll(e)}>
                                            {watchlists.sort((a, b) =>
                                                this.props.sortWatchlistsBy === 'MODIFICATION_DATE' ? (new Date(b?.ModificationDate) - new Date(a?.ModificationDate)) :
                                                    a?.Name.toLowerCase() > b?.Name.toLowerCase() ? 1 : -1)
                                                .map(x => ({
                                                    ...x,
                                                    WatchListLegislation: x?.WatchListLegislation.sort(sortLegislations)
                                                })).map((list, listIndex) =>
                                                    <React.Fragment key={listIndex}>
                                                        {list?.Name &&
                                                            <div role="button" disabled={(list.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All")))}
                                                                onClick={() => handleNavigation(listIndex)} onKeyDown={(e) => handleKeyDown(e, listIndex)} className={"watchlist-collection-item " + (this.props.selectedCollectionIndex === listIndex ? 'selected' : '')} tabIndex='0'>
                                                                <div className={this.props.selectedCollectionIndex === listIndex ? 'selected-collection' : ''}>
                                                                    <div className="small-text watchlist-name">{list.Name}{(list.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All"))) ? " (PAID)" : ""}</div>
                                                                    <div className="small-text txt-greyed">Last modified {list.ModificationDate ? moment(list.ModificationDate.replace(' +', '+')).tz('America/New_York').format('M/D/YYYY h:mm a') : moment().tz('America/New_York').format('M/D/YYYY h:mm a')}</div>
                                                                </div>
                                                                {listIndex !== watchlists.length - 1 && <hr className="faded-line" />}
                                                            </div>
                                                        }
                                                    </React.Fragment>
                                                )}
                                        </div>
                                    }
                                    <div className="homepage-links" style={{ textAlign: "center", marginTop: watchlists.length ? '10px' : '0px' }}>
                                        <Link to="/watchlists">All Watchlists</Link>
                                    </div>
                                </fieldset>
                            </div>
                            :
                            <div className="watchlist-login-wrapper homepage-links">
                                <Link style={{ marginLeft: "auto", marginRight: "auto", paddingTop: "5px", display: "table" }} to="/login?redirect=/bill-search">Log in to View Watchlists</Link>
                            </div>
                        }
                    </div>

                }
            </div>
        )
    }
}


export default connect(
    (state) => {
        const { login } = state;
        return {
            login,
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, authActionCreators), dispatch)
        }
    }
)(LegislationProfiles)
